/**
 * SidebarNavigationItemButton
 */
import * as React from 'react';

// Components
import SidebarNavigationItemIcon from '../SidebarNavigationItemIcon';

interface Props {
    onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
    iconName: string;
    title: string;
}

function SidebarNavigationItemButton(props: Props): JSX.Element {
    const { onClick, iconName, title } = props;

    return (
        <button
            onClick={onClick}
            className="sidebar-navigation-item button"
            type="button"
        >
            <SidebarNavigationItemIcon iconName={iconName} />
            <div className="sidebar-navigation-item-title">{title}</div>
        </button>
    );
}

export default SidebarNavigationItemButton;
